import Cookies from 'js-cookie';

const SESSION_DURATION_MS = 6 * 60 * 60 * 1000;
const SESSION_EXPIRES_AT_COOKIE = 'sessionExpiresAt';

function getSessionExpiryDate() {
    return new Date(Date.now() + SESSION_DURATION_MS);
}

function clearSessionDataOnly() {
    Cookies.remove('authToken');
    Cookies.remove('userUUID');
    Cookies.remove('user');
    Cookies.remove(SESSION_EXPIRES_AT_COOKIE);
    localStorage.removeItem('products');
    localStorage.removeItem('customers');
    localStorage.removeItem('enabledCustomers');
    localStorage.removeItem('tables');
    localStorage.removeItem('enabledTables');
    localStorage.removeItem('sale');
}

export function clearCurrentSession() {
    clearSessionDataOnly();
}

export function logoutAndRedirect() {
    clearSessionDataOnly();
    window.history.replaceState({}, '', '/login');
    window.dispatchEvent(new PopStateEvent('popstate'));
}

export function applySessionCookies(token, userForCookie) {
    const sessionExpiry = getSessionExpiryDate();
    Cookies.set('authToken', token, {expires: sessionExpiry});
    Cookies.set('user', JSON.stringify(userForCookie), {expires: sessionExpiry});
    Cookies.set(SESSION_EXPIRES_AT_COOKIE, String(sessionExpiry.getTime()), {expires: sessionExpiry});
    Cookies.remove('userUUID');
}

export function ensureSessionIsActive() {
    const token = Cookies.get('authToken');
    const user = Cookies.get('user');
    if (!token || !user) {
        return false;
    }
    const expiresAtRaw = Cookies.get(SESSION_EXPIRES_AT_COOKIE);
    if (!expiresAtRaw) {
        try {
            applySessionCookies(token, JSON.parse(user));
        } catch (error) {
            return false;
        }
        return true;
    }
    const expiresAt = Number(expiresAtRaw);
    if (!Number.isFinite(expiresAt) || Date.now() >= expiresAt) {
        return false;
    }
    return true;
}

export function renewActiveSession() {
    const token = Cookies.get('authToken');
    const userRaw = Cookies.get('user');
    if (!token || !userRaw) {
        return;
    }
    try {
        applySessionCookies(token, JSON.parse(userRaw));
    } catch (error) {
        // Cookie corrompido: sessão será considerada inválida no próximo request.
    }
}
